/* eslint-disable react/no-danger */
import React from 'react';
import cn from 'classnames';
import { isEmpty, map } from 'lodash';

import { Alert, AlertTitle, Grow } from '@mui/material';

import type { BannerMessage } from '@libraries/api/gen-api-hidden';

import { bannerTypeToSeverity } from '../../pages/admin/banners/bannersHelpers';

import styles from './StatusBanner.module.scss';

interface StatusBannerProps {
  banners?: Array<BannerMessage>;
  className?: string;
}

function StatusBanner({ banners, className }: StatusBannerProps) {
  if (isEmpty(banners)) {
    return null;
  }

  return (
    <Grow in>
      <div className={cn(styles.container, className)}>
        {map(banners, ({ type, title, message }) => (
          <Alert className={styles['status-banner']} key={title} severity={bannerTypeToSeverity(type)}>
            {title && <AlertTitle>{title}</AlertTitle>}
            <div className={styles['status-banner__message']} dangerouslySetInnerHTML={{ __html: message }} />
          </Alert>
        ))}
      </div>
    </Grow>
  );
}

export default StatusBanner;
